import styled from '@emotion/styled';

const CommentHeader = styled('header')({
  display: 'flex',
  alignItems: 'center',
});

export default CommentHeader;
